import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-face-analyzer"
    exact
    path="/business/products/ai-face-analyzer"
    component={AsyncPage}
  />,
];
